import { Stack, TextField } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import FileDownloadIcon from "@mui/icons-material/FileDownload";
import {
  colors,
  spacing,
  typography,
} from "../../../../../../../../../assets/styles/tokens";
import {
  CONVERSIONS_UPLOAD_LOOKBACK_DAYS,
  getConversionsUploadDateRange,
} from "../../../../../../helpers/bizDevelopmentDashboardHelpers";

interface ConversionsUploadFilterProps {
  onDownload?: () => void;
  downloadDisabled?: boolean;
}

const ConversionsUploadFilter = ({
  onDownload,
  downloadDisabled = false,
}: ConversionsUploadFilterProps) => {
  const { start, end } = getConversionsUploadDateRange();
  const dateRangeLabel = `Last ${CONVERSIONS_UPLOAD_LOOKBACK_DAYS} Days, ${start.format(
    "DD/MM/YYYY",
  )} - ${end.format("DD/MM/YYYY")}`;

  return (
    <>
      <Stack direction="row" justifyContent="space-between" alignItems="center">
        <TextField
          size="small"
          value={dateRangeLabel}
          disabled={true}
          slotProps={{ input: { readOnly: true } }}
          sx={{
            width: "85%",
            padding: "2px !important",
            "& .MuiInputBase-input": {
              fontSize: typography.Size.Text.sm.$value,
              lineHeight: typography.Line_height.text.sm.$value,
              fontWeight: typography.Font_weight.Semibold.$value,
              py: "5px !important",
            },
            "& .MuiOutlinedInput-root": {
              borderRadius: spacing.Radius.md.$value,
              "&.Mui-focused fieldset": {
                borderColor: colors.GrayLightMode[300].$value,
                borderWidth: "1px",
              },
            },
          }}
        />
        <IconButton
          color="secondary"
          size="large"
          onClick={onDownload}
          disabled={downloadDisabled}
          data-tracker="865"
        >
          <FileDownloadIcon sx={{ color: colors.GrayLightMode[700].$value }} />
        </IconButton>
      </Stack>
    </>
  );
};

export default ConversionsUploadFilter;
